/* Add expand/collapse enlargement CSS functionality to all post images */
(function() {

    // Will hold references to all of our posts' images on the current page
    var postImages = [];

    // When the DOM has loaded, grab a list of all of the images and
    // add the click handlers to each image
    document.addEventListener('DOMContentLoaded', function() {
        postImages = document.querySelectorAll('.post img');

        for (var i = 0; i< postImages.length; ++i) {

            var currentImage = postImages[i];

            currentImage.addEventListener('click', function(e) {
                var img = e.target;

                // Only allow the expand toggling for images that are larger
                // than currently displayed on the page
                if (img.classList.contains('expanded') || img.width < img.naturalWidth) {
                    img.classList.toggle('expanded');
                }
            });
        }
    });

    // When all assets have loaded, add a CSS is-expandable class to each
    // element where appropriate as a nicety
    window.addEventListener('load', function() {
        for (var i = 0; i< postImages.length; ++i) {

            var currentImage = postImages[i];

            if (currentImage.naturalWidth > currentImage.width) {
                currentImage.classList.add('is-expandable');
            }
        }
    });

})();